var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5174_34651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.97909 10.333L11.1533 11.9935L9.6383 13.613L8.05496 13.2841L7.81548 13.5401L9.0761 14.7194L9.83247 15.4269L10.841 16.3703L11.0805 16.1143L10.6468 14.5564L12.1618 12.9369L14.0301 15.9934L14.509 15.4814L13.7296 11.2609L15.58 9.28284C15.8446 8.99996 15.8333 8.55975 15.5547 8.29913C15.2761 8.03852 14.8361 8.05655 14.5715 8.33944L12.7211 10.3175L8.45805 9.82097L7.97909 10.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M6.26078 17.7364H9.39122C9.39122 17.7364 10.4347 17.9154 10.4347 18.7799C10.4347 19.6443 9.39122 19.8234 9.39122 19.8234H4.17383L4.17383 14.606C4.17383 14.606 4.17383 13.5625 5.21731 13.5625C6.26078 13.5625 6.26078 14.606 6.26078 14.606L6.26078 17.7364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.7826 17.7412V14.6107C18.7826 14.6107 18.9616 13.5673 19.826 13.5673C20.6905 13.5673 20.8695 14.6107 20.8695 14.6107V19.8281L15.6521 19.8281C15.6521 19.8281 14.6086 19.8281 14.6086 18.7846C14.6086 17.7412 15.6521 17.7412 15.6521 17.7412H18.7826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.7827 5.21671L15.6522 5.21671C15.6522 5.21671 14.6088 5.03768 14.6088 4.17323C14.6088 3.30879 15.6522 3.12976 15.6522 3.12976L20.8696 3.12976L20.8696 8.34715C20.8696 8.34715 20.8696 9.39062 19.8262 9.39062C18.7827 9.39062 18.7827 8.34715 18.7827 8.34715V5.21671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M6.2609 5.21977L6.2609 8.3502C6.2609 8.3502 6.08187 9.39368 5.21742 9.39368C4.35298 9.39368 4.17394 8.3502 4.17394 8.3502L4.17394 3.13281L9.39134 3.13281C9.39134 3.13281 10.4348 3.13281 10.4348 4.17629C10.4348 5.21977 9.39134 5.21977 9.39134 5.21977L6.2609 5.21977Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5174_34651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.5696f3a0239fb9f49fa934caadd54dda.svg";
export { ForwardRef as ReactComponent };